import React from 'react';
import Image from 'next/image';
import rightArrowNext from '../../svgs/right_arrow_icon.svg';
import { NextImageProps } from '../NextImageProps';

export function RightArrowNext({ className, width, height, alt }: NextImageProps) {
  return (
    <Image
      className={className}
      src={rightArrowNext}
      width={width}
      height={height}
      alt={alt ?? 'Til højre'}
    />
  );
}
